import { RotateCw } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionReschedule(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <RotateCw size={16} className='action_btn text-dark me-3'
                    onClick={onClick}
                    data-tooltip-id='reschedule'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id='reschedule' className='bg-dark tooltip_msg' />
        </>
    )
}